import hoist from 'hoist-non-react-statics'
import React from 'react'


export function chainDecorators(decorators = [], initialElement) {
  return decorators
    .slice(0)
    .reverse()
    .reduce((element, decorator) => decorator(element), initialElement)
}

export function memoized(WrappedComponent) {
  return hoist(React.memo(WrappedComponent), WrappedComponent)
}
